import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-generic.dialog',
  templateUrl: './generic.dialog.component.html',
  styleUrls: ['./generic.dialog.component.css']
})

export class GenericDialogComponent implements OnInit {
  title = "Title";
  message = "genericMessage";
  textButtonOne? = null;
  textButtonTwo? = null;
  isOneButton = null;

  iconColor = "" ;
  iconType = "";
  showIcon = false;

  constructor(
    private dialogRef: MatDialogRef<GenericDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.title = data.title;
    this.message = data.message;
    this.textButtonOne = data.textButtonOne ? data.textButtonOne : "Ok";
    this.textButtonTwo = data.textButtonTwo ? data.textButtonTwo : "Cancelar";
    this.isOneButton = data.isOneButton ? data.isOneButton : false;
    data.typeIconId = data.iconType;

    switch (data.typeIconId) {
      case 1:
        this.iconColor = "white";
        this.iconType = "check_circle";
        this.showIcon = true;
        break;
      case 2:
        this.iconColor = "white";
        this.iconType = "warning";
        this.showIcon = true;
        break;
      case 3:
        this.iconColor = "white";
        this.iconType = "error_outline";
        this.showIcon = true;
        break;
      default:
        this.iconColor = "";
        this.iconType = "";
        this.showIcon = false;
        break;
    }
  }

  ngOnInit(): void {
  }

  buttonOneClick() {
    this.dialogRef.close(true);
  }

  buttonTwoClick() {
    this.dialogRef.close(false);
  }

}